import { createSelector } from "reselect";

const selectSlice = (state) => state.ReportReducer || {};

export const selectCostReport = createSelector(selectSlice, (s) => s.costReport || null);
export const selectCostReportLoading = createSelector(selectSlice, (s) => s.costReportLoading || false);

// KPIs from cost report
export const selectCostKpis = createSelector(selectCostReport, (r) => r?.kpis || null);

// Cost breakdown (cost types + categories)
export const selectCostBreakdownReport = createSelector(selectCostReport, (r) => r?.cost_breakdown || []);

// Monthly trends
export const selectMonthlyTrends = createSelector(selectCostReport, (r) => r?.monthly_trends || []);

// Revenue KPIs from units
export const selectRevenueKpis = createSelector(selectCostReport, (r) => r?.revenue_kpis || null);

// Profitability (ROI / ROE / equity) for the Overview tab
export const selectProfitability = createSelector(selectCostReport, (r) => r?.profitability || null);

// Revenue flow (collected / scheduled / unscheduled)
export const selectRevenueFlow = createSelector(selectCostReport, (r) => r?.revenue_flow || null);

// Currency the backend already converted everything into
export const selectReportCurrency = createSelector(selectCostReport, (r) => r?.currency || 'RON');

// Active currency — whichever report is currently loaded (block view loads blockReport, not costReport)
export const selectActiveCurrency = createSelector(
  selectSlice,
  (s) => s.blockReport?.currency || s.costReport?.currency || 'RON'
);

// Cost summary for scroll bar: [{ cost_type_id, cost_type, amount, budget, currency }]
export const selectCostSummary = createSelector(selectSlice, (s) => s.costSummary || []);
export const selectCostSummaryLoading = createSelector(selectSlice, (s) => s.costSummaryLoading || false);

// Block report
export const selectBlockReport        = createSelector(selectSlice, (s) => s.blockReport || null);
export const selectBlockReportLoading = createSelector(selectSlice, (s) => s.blockReportLoading || false);
export const selectBlockMetadata      = createSelector(selectBlockReport, (r) => r?.block_metadata || null);
export const selectBlockRevenueKpis   = createSelector(selectBlockReport, (r) => r?.revenue_kpis || null);
export const selectBlockRevenueFlow   = createSelector(selectBlockReport, (r) => r?.revenue_flow || null);
export const selectBlockCostBreakdown = createSelector(selectBlockReport, (r) => r?.cost_breakdown || []);
export const selectBlockCostKpis      = createSelector(selectBlockReport, (r) => r?.kpis || null);
export const selectUnitBreakdown      = createSelector(selectBlockReport, (r) => r?.unit_breakdown || []);
